import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import * as ui from '../../redux/actionCreators/sync/ui';

@connect(store => ({
    ui: store.ui
}))

export default class SnackBar extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    actionText: PropTypes.string,
    action: PropTypes.func,
    hideAction: PropTypes.func,
    show: PropTypes.bool.isRequired,
    snackBarText: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props);
    this.state = {
      showSnackBar: false
    };

    this.hideSnackbar = this.hideSnackbar.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const {showSnackBar} = this.state;
    if (showSnackBar !== nextProps.show) {
      this.setState({
        showSnackBar: nextProps.show
      });

      if (nextProps.show) {
        setTimeout(() => {
          this.hideSnackbar();
          if (this.props.hideAction) {
            this.props.hideAction();
          }
        }, 3000);
      }
    }
  }

  hideSnackbar() {
    this.props.dispatch(ui.hideSnackBar());
    this.setState({
      showSnackBar: false
    });
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const {actionText, action, show, snackBarText} = this.props;
    const {showSnackBar} = this.state;

    const snackbarContainer = {
      maxWidth: '980px',
      width: '100%',
      marginLeft: '265px',
      position: 'fixed',
      left: 0,
      right: 0,
      bottom: '-50px',
      zIndex: 2000,
      WebkitTransition: 'bottom 200ms cubic-bezier(0, 0, 0.30, 1)',
      transition: 'bottom 200ms cubic-bezier(0, 0, 0.30, 1)',
      textTransform: 'initial',
    };

    const snackbarStyle = {
      width: '50%',
      minHeight: '50px',
      background: '#323232',
      color: '#fff',
      margin: 'auto',
      display: '-webkit-box',
      // eslint-disable-next-line no-dupe-keys
      display: '-ms-flexbox',
      // eslint-disable-next-line no-dupe-keys
      display: 'flex',
      WebkitBoxAlign: 'center',
      msFlexAlign: 'center',
      alignItems: 'center',
      WebkitBoxPack: 'justify',
      msFlexPack: 'justify',
      justifyContent: 'space-between',
      fontWeight: '500',
      fontSize: '14px',
    };

    const snackbarTextStyle = {
      marginLeft: '15px',
      wordBreak: 'break-all',
      flexGrow: 1
    };

    const snackbarActionStyle = {
      textTransform: 'uppercase',
      color: '#2eb0e3',
      cursor: 'pointer',
      marginRight: '15px',
      border: 0,
      background: 'transparent',
      fontSize: '13px',
      outline: 0
    };

    if (showSnackBar) {
      snackbarContainer.bottom = 0;
    }
    else {
      snackbarContainer.bottom = '-50px';
    }

    return(
      <div data-id='snackbar' style={snackbarContainer}>
        <div style={snackbarStyle}>
          <p style={snackbarTextStyle}>{snackBarText}</p>
          <div style={snackbarActionStyle} onClick={this.props.action || this.hideSnackbar}>{actionText}</div>
        </div>
      </div>
    );
  }
}

SnackBar.defaultProps = {
  actionText: 'OK'
};

SnackBar.propTypes = {
  actionText: PropTypes.string,
  action: PropTypes.func,
  hideAction: PropTypes.func,
  show: PropTypes.bool.isRequired,
  snackBarText: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./shared/common/components/SnackBar.js